import { render, staticRenderFns } from "./FactSheets.vue?vue&type=template&id=22f77af1&"
import script from "./FactSheets.vue?vue&type=script&lang=js&"
export * from "./FactSheets.vue?vue&type=script&lang=js&"
import style0 from "./FactSheets.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports